import { Allocation } from './Allocation';
import { BaseModel } from './BaseModel';

export class ServerSubdomain extends BaseModel {
    public id = -1;
    public name = '';
    public displayName = '';
    public hasSrv = false;

    public get allocation(): Allocation | undefined {
        return this.getRelationship('allocation');
    }
}
